import React, { useState } from 'react';
import NamedBox from '../atoms/NamedBox';
import CloseButton from '../atoms/CloseButton';
import ListItem from '../atoms/ListItem';
import ClassIcon from '../icons/ClassIcon';
import SchoolIcon from '../icons/SchoolIcon';
import EmailIcon from '../icons/EmailIcon';
import PhoneIcon from '../icons/PhoneIcon';
import MapIcon from '../icons/MapIcon';
import CoachIcon from '../icons/CoachIcon';
import AgentIcon from '../icons/AgentIcon';
import TrainerIcon from '../icons/TrainerIcon';
import Links from './Links';
import { COLOR_BLUE, COLOR_MIDDLE_GRAY } from '../styles/colors';
import {
    Box,
    makeStyles,
    Typography,
  } from '@material-ui/core';
import UserCircleIcon from '../icons/UserCircleIcon';
import HomeIcon from '../icons/HomeIcon';
import NotAvailable from '../atoms/NotAvailable';


const useStyles = makeStyles(theme => ({
    listItem: {
      padding: theme.spacing(.5, 2.5),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.2,
  
      '& a': {
        color: COLOR_BLUE
      }
    },
    dividedContent: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(.5, 2),
    },
    dividedContentSection: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '30px',
      paddingRight: theme.spacing(2),
      borderRight: `1px solid ${COLOR_MIDDLE_GRAY}`,
  
      '&:last-child': {
        paddingRight: 0,
        borderRight: 0,
      },
    },
    progressLine: {
      padding: 0,
    },
    recruitingLinks: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '200px',
      padding: theme.spacing(1),
    },
    recruitingLink: {
    },
    rankingWrap: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: '230px',
      gap: theme.spacing(2),
      padding: theme.spacing(2, 0),
    },
    rankingContent: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 'auto',
      fontWeight: 700,
    },
    rankingIcon: {
      maxWidth: '28px',

      '& img': {
        display: 'block',
        maxWidth: '100%',
      }
    },
    socialProfile: {
      marginLeft: theme.spacing(3),

      '&:first-of-type': {
        marginLeft: 0,
      },
    },
    closeButton: {
      marginLeft: 'auto',
    },
  }), { name: ContactContent.name });

export default function ContactContent(props: any) {
    const classes = useStyles();

    const primarySchool = props?.primarySchool;
    const player = props?.player;
    const links = props?.links;
    const socialLinks = props?.socialLinks;
    const latestAgency = player?.playerAgencies?.filter((a: any) => a.id)?.sort((a: any, b: any) => b.id - a.id)?.[0];    

    return (
      <NamedBox
      name={`Contact ${player?.firstName || ''} ${player?.lastName || ''}`}
      headerContent={<CloseButton className={classes.closeButton} onClick={props?.onClose} />}
      >
        {(player && !!player.email) && (
          <ListItem
            icon={EmailIcon}
            title='Player Contact:'
            className={classes.listItem}
          >
            <div className={classes.dividedContent}>
              <div className={classes.dividedContentSection}>
                <b><a href="mailto:{player.email}">{player.email}</a></b>
              </div>

              <div className={classes.dividedContentSection}>
                <Links links={socialLinks} linkClassName={classes.socialProfile} />
              </div>
            </div>
          </ListItem>
        )}

        {(player && !!player.cellPhone) && (
          <ListItem
            icon={PhoneIcon}
            title='Player Phone:'
            className={classes.listItem}
          >
            <b>{player.cellPhone}</b>
          </ListItem>
        )}

        {(player && (player.address || player.cityStateZip)) && (
          <ListItem
            icon={MapIcon}
            title='Address:'
            className={classes.listItem}
          >
            <div className={classes.dividedContent}>
              <div className={classes.dividedContentSection}>
                <b>{player.address || <NotAvailable />}</b>
              </div>

              {player?.cityStateZip && (
                <div className={classes.dividedContentSection}>
                  <b>{player?.cityStateZip}</b>
                </div>
              )}
            </div>
          </ListItem>
        )}

        <ListItem
          icon={UserCircleIcon}
          title='Parent Name(s):'
          className={classes.listItem}
        >
          <div className={classes.dividedContent}>
            <div className={classes.dividedContentSection}>
              <b>{player?.parentNames || <NotAvailable />}</b>
            </div>
              
            {player?.parentContact && (
              <div className={classes.dividedContentSection}>
                <b>{player?.parentContact || <NotAvailable />}</b>
              </div>
            )}
          </div>
        </ListItem>

        {player && (
          <ListItem
            icon={CoachIcon}
            title='Head Coach:'
            className={classes.listItem}
          >
            <div className={classes.dividedContent}>
              <div className={classes.dividedContentSection}>
                <b>{player?.headCoach || <NotAvailable />}</b>
              </div>
              
              {player?.headCoachContact && (
                <div className={classes.dividedContentSection}>
                  <b>{player?.headCoachContact || <NotAvailable />}</b>
                </div>
              )}
            </div>
          </ListItem>
        )}

        {player && (
          <ListItem
            icon={AgentIcon}
            title='Agent:'
            className={classes.listItem}
          >
            <div className={classes.dividedContent}>
              <div className={classes.dividedContentSection}>
                <b>{latestAgency?.agentName || <NotAvailable />}</b>
              </div>
              <div className={classes.dividedContentSection}>
                <b>{latestAgency?.agentContact || <NotAvailable />}</b>
              </div>
            </div>
          </ListItem>
        )}

        {player && (
          <ListItem
            icon={TrainerIcon}
            title='Trainer:'
            className={classes.listItem}
          >
            <div className={classes.dividedContent}>
              <div className={classes.dividedContentSection}>
                <b>{player?.trainerInfo || <NotAvailable />}</b>
              </div>
            </div>
          </ListItem>
        )}

        <ListItem
          icon={SchoolIcon}
          title='School:'
          className={classes.listItem}
        >
          <div className={classes.dividedContent}>
            <div className={classes.dividedContentSection}>
              <span><strong>{(primarySchool?.name || <NotAvailable />)}</strong></span>
            </div>

            <div className={classes.dividedContentSection}>
              <span>GPA: <strong>{player?.gpa || <NotAvailable />}</strong> </span>
            </div>

            <div className={classes.dividedContentSection}>
              <span>SAT: <strong>{player?.sat || <NotAvailable />}</strong></span>
            </div>

            <div className={classes.dividedContentSection}>
              <span>ACT: <strong>{player?.act || <NotAvailable />}</strong></span>
            </div>
          </div>
        </ListItem>

        <ListItem
          icon={ClassIcon}
          title='Class:'
          className={classes.listItem}
        >
          <b>{(primarySchool && primarySchool.graduatingClass) || 0}</b>
        </ListItem>

        <ListItem
          icon={HomeIcon}
          title="Hometown:"
          className={classes.listItem}
        >
          <b>
            {primarySchool?.city || <NotAvailable />}
            {primarySchool?.city && primarySchool?.state ? ', ' : ''}            
            {primarySchool?.state || <NotAvailable />}
          </b>
        </ListItem>
      </NamedBox>
    )
  }